import React, { useState } from "react"
import { Button, Divider, Modal, Typography, message } from "antd"
import { CloseCircleFilled } from "@ant-design/icons"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import { useAuthContext } from "../../../../hooks/useAuthContext"
import { updateProductOrdersArray } from "../../../../utils/updateProductOrdersArray"

const { Text } = Typography

const FillStopRequest = (props) => {
  //gets users
  const { user } = useAuthContext()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
    console.log(props.data)
  }
  const handleOk = async () => {
    updateStopOrder()
  }
  const handleCancel = () => {
    cancelStopOrder()
  }

  //update stop order
  const updateStopOrder = async () => {
    const ref = doc(db, "orders", props.data.id)
    try {
      await updateDoc(ref, {
        orderStatus: 999,
        requestedToStop: false,
        orderStopped: serverTimestamp(),
        stoppedBy: user.email,
      })
      await updateProductOrdersArray("remove", props.data)
    } catch (error) {
      message.error("error happened")
      console.log(error)
    } finally {
      message.success("updated")
      setIsModalOpen(false)
    }
  }
  //cancel stop order
  const cancelStopOrder = async () => {
    const ref = doc(db, "orders", props.data.id)
    try {
      await updateDoc(ref, {
        requestedToStop: false,
      })
    } catch (error) {
      message.error("error happened")
      console.log(error)
    } finally {
      message.success("updated")
      setIsModalOpen(false)
    }
  }

  return (
    <>
      <Button
        onClick={showModal}
        ghost
        type="primary"
        size="small"
        icon={<CloseCircleFilled style={{ color: "#f5222d" }} />}>
        Stop
      </Button>
      <Modal
        title="Fill Stop request"
        okText="Stop The Order"
        cancelText="Cancel stop request"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}>
        <Divider>Stop Request comment </Divider>
        <Text>{props.data.stopRequestComment}</Text>
      </Modal>
    </>
  )
}

export default FillStopRequest
